import React from 'react';
import { Beaker, Droplets, Wind, Clock, Sparkles, ClipboardCheck, ShoppingBag } from 'lucide-react';
export function RoadmapSection() {
  const days = [{
    day: 1,
    title: 'Proper Setup',
    icon: Beaker,
    desc: 'Environment control & safety'
  }, {
    day: 2,
    title: 'Perfect Ratios',
    icon: Droplets,
    desc: 'The science of mixing'
  }, {
    day: 3,
    title: 'Bubble Control',
    icon: Wind,
    desc: 'De-gassing techniques'
  }, {
    day: 4,
    title: 'Controlled Curing',
    icon: Clock,
    desc: 'Temperature management'
  }, {
    day: 5,
    title: 'Pro Finishing',
    icon: Sparkles,
    desc: 'Sanding & polishing'
  }, {
    day: 6,
    title: 'Quality Check',
    icon: ClipboardCheck,
    desc: 'Sell-ready standards'
  }, {
    day: 7,
    title: 'Publish & Sell',
    icon: ShoppingBag,
    desc: 'Packaging & photography'
  }];
  return <section className="py-20 bg-[#FDFCF8]" data-id="element-124">
      <div className="container mx-auto px-4" data-id="element-125">
        <div className="text-center mb-16" data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-127">
            How The 7-Day Error-Free Resin™ System Works
          </h2>
          <p className="text-stone-600" data-id="element-128">
            A structured, technical path to mastery.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto" data-id="element-129">
          {days.map((item, idx) => <div key={idx} className={`
                bg-white p-6 rounded-xl shadow-sm border border-stone-100 flex flex-col items-center text-center hover:shadow-md transition-shadow
                ${idx === 6 ? 'col-span-2 md:col-span-2 bg-teal-50 border-teal-100' : ''}
              `} data-id="element-130">
              <div className="w-12 h-12 rounded-full bg-stone-100 flex items-center justify-center mb-4 text-stone-600" data-id="element-131">
                <item.icon className="w-6 h-6" data-id="element-132" />
              </div>
              <div className="text-xs font-bold text-teal-600 uppercase tracking-wider mb-1" data-id="element-133">
                Day {item.day}
              </div>
              <h3 className="text-lg font-bold text-stone-900 mb-2" data-id="element-134">
                {item.title}
              </h3>
              <p className="text-sm text-stone-500" data-id="element-135">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}